export default __webpack_public_path__ + "assets/models/88a742aecd692612b4fa5b47f4d2eb49.glb";